const initialState = {
  readNotifications: [],
  lastVisible: null,
  hasMoreDocument: true,
  unreadNotifications: [],
  unreadLastVisible: null,
  unreadHasMore: true,
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_READ_NOTIFICATIONS":
      return {
        ...state,
        readNotifications: action.payload.data,
        lastVisible: action.payload.lastVisible || null,
        hasMoreDocument: action.payload.hasMoreDocument ?? false,
      };

    case "LOAD_MORE_READ_NOTIFICATIONS":
      return {
        ...state,
        readNotifications: [...state.readNotifications, ...action.payload.data],
        lastVisible: action.payload.lastVisible || null,
        hasMoreDocument: action.payload.hasMoreDocument ?? false,
      };
    case "GET_UNREAD_NOTIFICATIONS":
      return {
        ...state,
        unreadNotifications: action.payload.data,
        unreadLastVisible: action.payload.lastVisible,
        unreadHasMore: action.payload.hasMoreDocument,
      };

    case "LOAD_MORE_UNREAD_NOTIFICATIONS":
      return {
        ...state,
        unreadNotifications: [
          ...state.unreadNotifications,
          ...action.payload.data,
        ],
        unreadLastVisible: action.payload.lastVisible,
        unreadHasMore: action.payload.hasMoreDocument,
      };

    default:
      return state;
  }
};

export default notificationsReducer;
